import { HomepageRoutingModule } from './homepage-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './components/banner/banner.component';
import { HomepageMainComponent } from './components/main/main.component';
import { SharedModule } from '../shared/shared.module';
import { NgxGlideModule } from 'ngx-glide';
import { SipTopBannerModule } from './../common/sip-top-banner/sip-top-banner.module';
import { DownloadAppBannerModule } from '../common/download-app-banner/download-app-banner.module';

import {
  CausesComponent,
  CommunityComponent,
  CrowdfundingComponent,
  TrendingFundraiersComponent,
  WhatweofferComponent,
  HowtogetstartedComponent,
  SuccesstoriesComponent,
  FundraisingfeatureComponent,
  FeaturedinComponent,
  RaisedDonorsFrComponent
} from './components';
import { TalkToUsBtnModule } from '../common/talk-to-us-btn/talk-to-us-btn.module';
import { CardViewModule } from '../common/card-view/card-view.module';
import { CausesListModule } from '../common/causes-list/causes-list.module';
import { ChatWithUsModule } from '../common/chat-with-us/chat-with-us.module';
import { CommonHeaderModule } from '../common/common-header/common-header.module';
import { CommonTalktousModalModule } from '../common/common-talktous-modal/common-talktous-modal.module';
import { ExitIntentModule } from '../common/exit-intent/exit-intent.module';
import { FooterModule } from '../common/footer/footer.module';
import { HomepageSipBannerModule } from '../common/homepage-sip-banner/homepage-sip-banner.module';
import { HowToStartedModule } from '../common/how-to-started/how-to-started.module';
import { LandscapeViewModule } from '../common/landscape-view/landscape-view.module';
import { SacFlowModule } from '../common/sac-flow/sac-flow.module';
import { StartFundraiserWidgetModule } from '../common/start-fundraiser-widget/start-fundraiser-widget.module';
import { StartfundraiserButtonModule } from '../common/startfundraiser-button/startfundraiser-button.module';
import { TalkToUsCardModule } from '../common/talk-to-us-card/talk-to-us-card.module';
import { UrgentFrModule } from '../common/urgent-fr/urgent-fr.module';
import { WidgetModule } from '../common/widget/widget.module';
import { ZendeskChatModule } from '../common/zendesk-chat/zendesk-chat.module';
import { ZohoChatModule } from '../common/zoho-chat/zoho-chat.module';
import { StoryPromoModule } from '../common/story-promo/story-promo.module';
import { MatButtonModule } from '@angular/material/button';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { ComponentLoader } from '../core/component-loader/component-loader.component';
@NgModule({
  imports: [
    CausesListModule,
    CommonHeaderModule,
    CommonModule,
    FooterModule,
    HomepageRoutingModule,
    SharedModule,
    MatButtonModule,
    CommonTalktousModalModule,
    UrgentFrModule,
    WidgetModule,
    LandscapeViewModule,
    ExitIntentModule,
    ChatWithUsModule,
    StartFundraiserWidgetModule,
    HowToStartedModule,
    TalkToUsCardModule,
    ZendeskChatModule,
    ZohoChatModule,
    SacFlowModule,
    CardViewModule,
    StartfundraiserButtonModule,
    NgxGlideModule,
    TalkToUsBtnModule,
    SipTopBannerModule,
    HomepageSipBannerModule,
    DownloadAppBannerModule,
    StoryPromoModule,
    ModuleLoaderModule,
    ComponentLoader
  ],
  exports: [TrendingFundraiersComponent],
  declarations: [
    BannerComponent,
    HomepageMainComponent,
    CausesComponent,
    CommunityComponent,
    CrowdfundingComponent,
    TrendingFundraiersComponent,
    WhatweofferComponent,
    HowtogetstartedComponent,
    SuccesstoriesComponent,
    FundraisingfeatureComponent,
    FeaturedinComponent,
    RaisedDonorsFrComponent
  ]
})
export class HomepageModule { }
